import { range } from "lodash"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum MakeVideoAudio {
    INTRO = "make-video-n01.mp3",
    CHOOSE_MUSIC = "make-video-n02.mp3",
    CHOOSE_VIDEO = "make-video-n03.mp3",
    CHOOSE_TITLE_SCREEN = "make-video-n04.mp3",
    CLICK_TITLE = "make-video-n05.mp3",
    CHOOSE_BACKGROUND = "make-video-n06.mp3",
    PLAY_VIDEO = "make-video-n07.mp3",
    CHOOSE_ANOTHER_MUSIC = "make-video-n08-1.mp3",
    CHOOSE_ANOTHER_VIDEO = "make-video-n08-2.mp3",
    CHOOSE_ANOTHER_TITLE = "make-video-n09.mp3",
    CLICK_NEW_BACKGROUND = "make-video-n12.mp3",
    PLAY_EDITED_VIDEO = "make-video-n13.mp3",
    FINISHED_VIDEO_EDIT = "make-video-n14.mp3",
    FINISHED_VIDEO_NEXT = "make-video-n15.mp3",
    STUPID_SINGING_SMOKER = "make-video-title-stupid-singing-smoker.mp3",
    STUPID_SMOKER = "make-video-title-stupid-smoker.mp3",
    UNCOOL_SINGING_SMOKER = "make-video-title-uncool-singing-smoker.mp3",
    UNCOOL_SMOKER_DUDE = "make-video-title-uncool-smoker-dude.mp3",
    UNPOPULAR_SMOKER = "make-video-title-unpopular-smoker.mp3",
    UNPOPULAR_SMOKER_DUDE = "make-video-title-unpopular-smoker-dude.mp3",
    COUNTRY = "country.mp3",
    HIP_HOP = "hip-hop.mp3",
    POP = "pop.mp3",
}

export enum MakeVideoImages {
    BAND = "band.png",
    TITLE = "title.png",
    VIDEO_TARGET = "base-target.png",
    VIDEO_TIMELINE = "video-timeline.png",
}

export enum MakeVideoAtlases {
    CROWD_JUMPING = "crowd-jumping.json",
    INTRO_TATE = "intro-tate.json",
    THOUGHT_BUBBLE = "thought-bubble.json",
    COUNTRY_BUTTON = "country-music.json",
    HIP_HOP_BUTTON = "hip-hop-button.json",
    POP_BUTTON = "pop-button.json",
    STEP_DISPLAY = "step-count.json",
    CURRENT_STEP = "step-numbers.json",
    PLAY_BUTTON = "play-button.json"
}

export const getMakeVideoVideoTitle = (index: number): string => `make-your-own-video-clip-${index}.mp4`

export const getMakeVideoVideoPreview = (index: number): string => `video-preview-${index}.png`

export const getMakeVideoVideoTile = (index: number): string =>  `video-tile-${index}.png`

// tslint:disable-next-line
function addMakeVideoVideos(loader: {video, image}) {
    range(1, 9).forEach(index => {
        const vid = getMakeVideoVideoTitle(index)
        const preview = getMakeVideoVideoPreview(index)
        const tile = getMakeVideoVideoTile(index)
        loader.image(preview, preview)
        loader.image(tile, tile)
        loader.video(vid, vid)
    })
    range(1, 7).forEach(index => loader.image(`background-${index}.png`, `background-${index}.png`))
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "make-video")
    load.autoLoad({audioEnum: MakeVideoAudio, imageEnum: MakeVideoImages, atlasEnum: MakeVideoAtlases})
    addMakeVideoVideos(load)
}
